import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar20Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar20 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar20Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar20">
        <G id="Group 1538228683">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M136.422 235.408c-33.832-5.362-54.35.492-68.72 2.423-14.163 1.898-24.585 6.196-32.267 11.478 27.85 33.228 69.658 54.358 116.405 54.358 34.269 0 65.877-11.351 91.28-30.503-20.629-11.852-75.972-32.887-106.698-37.756Z"
            fill="#000"
          />
          <G id="Group">
            <Path
              id="skin"
              d="M220.425 155.551c2.042-11.391-.921-13.6-.921-28.263 1.748-39.758-2.899-76.378-41.219-76.378-69.189 0-76.108 18.977-76.108 63.398 0 2.311-.389 1.453-.182 3.845-6.562 0-12.225 14.29-9.35 23.195 6.736 20.86 22.719 21.146 23.037 20.971 2.613 6.14-3.083 45.644-4.814 52.69-2.804 11.375-24.125 21.002-24.125 21.002s68.474 55.756 97.19 53.087c9.564 0 6.243-34.133 2.605-39.201-3.646-5.068-9.77-3.48-13.663-10.518-1.652-2.986-.039-21.495.652-33.664 9.341-1.406 18.905 4.361 28.175-5.545 6.085-6.498 16.221-30.583 18.723-44.595v-.024Z"
              fill={c.skin}
            />
            <Path
              id="Vector_2"
              d="M139.178 114.777s12.059-3.79 21.44-3.726c11.018.079 18.763 7.451 20.884 3.686.675-1.2.214-7.507-19.867-9.572-8.992-.93-14.275 3.288-22.449 9.619l-.008-.007Z"
              fill="#000"
            />
            <Path
              id="Vector_3"
              d="M178.404 130.831c-2.717-4.647-7.221-8.929-12.877-9.97a15.763 15.763 0 0 0-7.554.93c-1.986.755-3.511 2.018-4.981 3.273-1.994 1.374-4.639.85-7.03.572 2.264 1.58 5.616 2.851 8.365 1.493a23.293 23.293 0 0 1 1.914-1.12c-.016.199-.04.397-.04.604 0 3.693 3.098 6.688 6.919 6.688 3.821 0 6.919-2.995 6.919-6.688 0-.302-.024-.596-.064-.89 2.709 1.247 5.442 3.09 8.436 5.108h-.007Z"
              fill="#000"
            />
            <Path
              id="Vector_4"
              opacity={0.75}
              d="M198.906 117.009c-.262-.373-.254-.977.079-1.708-9.452 13.56 3.607 35.381-1.485 39.496-3.559 2.875-16.999-1.144-17.523 2.534 4.893 3.09 18.373 5.56 22.456-1.589 1.597-3.686-8.968-28.231 1.509-38.749-1.986 1.414-4.154 1.263-5.028.016h-.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_5"
              opacity={0.75}
              d="M142.602 205.531c13.266 11.614 20.82 15.149 29.375 16.07-.158-6.807 1.542-16.236 1.168-16.371-18.858-6.681-27.071-12.79-42.379-26.31-5.576-4.925-10.581-12.026-14.894-18.524 0 .429.064.937 0 2.518 2.145 9.588 8.412 26.587 26.73 42.617Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_6"
              opacity={0.75}
              d="M165.686 170.175c.826.715 12.273 13.735 25.11 13.266 10.93-.405 14.465-11.121 14.727-11.661 0 0-4.83-4.623-8.19-4.496-3.36.127-5.703 1.779-5.703 1.779s-3.027-1.811-6.593-1.676c-3.567.135-6.744 1.994-10.089 2.558-3.376.564-9.262.238-9.262.238v-.008Zm4.615 2.082c-.095-.048-.008-.151.096-.12 4.09 1.47 11.176 2.463 22.17 2.058 5.664-.207 9.405-.389 12.503-1.422-3.09 1.271-7.157 4.71-12.805 4.917-11.018.405-17.913-3.273-21.956-5.441l-.008.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_7"
              d="M219.695 107.389c-13.179-.397-22.203 6.911-20.789 9.628.874 1.676 3.567 1.747 5.545-.151 5.433-4.663 9.659-3.106 15.355-3.186.127-1.93-.087-4.686-.111-6.291Z"
              fill="#000"
            />
            <Path
              id="Vector_8"
              d="M224.833 125.699c-1.469-1.255-2.994-2.51-4.98-3.273-2.423-.937-5.005-1.231-7.555-.929-5.655 1.04-10.159 5.322-12.876 9.969 1.541-1.041 3.003-2.034 4.44-2.915.262 3.249 3.067 5.806 6.498 5.806 3.607 0 6.522-2.828 6.522-6.307 0-1.183-.358-2.28-.945-3.225 2.335.262 4.813 1.168 7.562 2.939 2.748 1.359 6.1.088 8.364-1.493-2.399.278-5.044.802-7.03-.572Z"
              fill="#000"
            />
            <Path
              id="hair"
              d="M230.331 35.333c-18.572-15.617-36.548 2.129-36.548 2.129s-.445.357.739-4.679c-4.647 3.098-7.277 10.756-8.532 15.697-18.413-6.387-40.162-8.706-58.012-3.384.89-4.647.668-8.818-.985-11.67-4.774-8.237-7.991-9.548-7.991-9.548l1.486 5.45s-8.119-9.509-15.951-9.509c-7.832 0-8.714 2.28-8.714 2.28S82.374 18.961 75.2 28.271c-7.18 9.318-5.123 14.418-5.123 14.418s-7.8 3.876-7.022 10.628c2.74 23.776 14.147 29.884 26.063 28.494-8.182 15.871-10.804 32.855-4.576 48.781 9.453 24.157 28.549 44.31 31.329 45.708.699-6.387 0-15.903 0-15.903s-33.077-11.836-18.333-36.096c12.535-6.148 24.72 12.535 24.72 12.535s5.457-5.807 4.989-11.955c-.461-6.148-.58-8.237 2.669-11.145 3.249-2.899 17.809-14.076 18.167-20.55.357-6.474 5.393-11.145 5.393-11.145s-15.641-5.036-21.209-11.502c13.48 4.67 19.057 9.89 24.808 8.992 5.751-.897 8.992-6.291 14.743-6.649 5.751-.357 13.711-.603 13.711-.603s-.469-8.198-7.944-17.135c4.139-.15 9.786 8 11.701 17.715 8.213 1.366 19.708 2.192 23.95 15.466 4.242 13.273 7.8 25.459 7.8 25.459s2.415-12.344.302-26.222c1.97.056 4.059-.032 5.442-.032 2.947 0 6.211-3.701 7.466-5.711 1.255-2.01 2.384-3.074 7.722-7.817 5.338-4.742 4.662-24.958-11.63-38.66l-.008-.009Z"
              fill={c.hair}
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};
